document.addEventListener("DOMContentLoaded", function () {
  if (window.formSubmitted) return;
  window.formSubmitted = true;

  const productPricing = {
    'step-stone-type': {
      'champagne-diamond': {
        '0.75': {
          'round': 1760.0,
          'oval': 1584.0,
          'pear': 1584.0,
          'emerald': 1196.8,
          'radiant': 1196.8,
          'asscher': 1136.96,
          'marquise': 1760.0,
          'cushion': 1144.0
        },
        '1.00': {
          'round': 3200.0,
          'oval': 2880.0,
          'pear': 2880.0,
          'emerald': 2176.0,
          'radiant': 2176.0,
          'asscher': 2067.2,
          'marquise': 3200.0,
          'cushion': 2080.0
        },
        '1.25': {
          'round': 6080.0,
          'oval': 5472.0,
          'pear': 5472.0,
          'emerald': 4134.4,
          'radiant': 4134.4,
          'asscher': 3927.68,
          'marquise': 6080.0,
          'cushion': 3952.0
        },
        '1.50': {
          'round': 7840.0,
          'oval': 7056.0,
          'pear': 7056.0,
          'emerald': 5331.2,
          'radiant': 5331.2,
          'asscher': 5064.64,
          'marquise': 7840.0,
          'cushion': 5096.0
        },
        '1.75': {
          'round': 12160.0,
          'oval': 10944.0,
          'pear': 10944.0,
          'emerald': 8268.8,
          'radiant': 8268.8,
          'asscher': 7855.36,
          'marquise': 12160.0,
          'cushion': 7904.0
        },
        '2.00': {
          'round': 16000.0,
          'oval': 14400.0,
          'pear': 14400.0,
          'emerald': 10880.0,
          'radiant': 10880.0,
          'asscher': 10336.0,
          'marquise': 16000.0,
          'cushion': 10400.0
        },
        '2.25': {
          'round': 16000.0,
          'oval': 14400.0,
          'pear': 14400.0,
          'emerald': 10880.0,
          'radiant': 10880.0,
          'asscher': 10336.0,
          'marquise': 16000.0,
          'cushion': 10400.0
        },
        '2.50': {
          'round': 24000.0,
          'oval': 21600.0,
          'pear': 21600.0,
          'emerald': 16320.0,
          'radiant': 16320.0,
          'asscher': 15504.0,
          'marquise': 24000.0,
          'cushion': 15600.0
        },
        '2.75': {
          'round': 24000.0,
          'oval': 21600.0,
          'pear': 21600.0,
          'emerald': 16320.0,
          'radiant': 16320.0,
          'asscher': 15504.0,
          'marquise': 24000.0,
          'cushion': 15600.0
        },
        '3.00': {
          'round': 41600.0,
          'oval': 37440.0,
          'pear': 37440.0,
          'emerald': 28288.0,
          'radiant': 28288.0,
          'asscher': 26873.6,
          'marquise': 41600.0,
          'cushion': 27040.0
        },
        '3.25': {
          'round': 41600.0,
          'oval': 37440.0,
          'pear': 37440.0,
          'emerald': 28288.0,
          'radiant': 28288.0,
          'asscher': 26873.6,
          'marquise': 41600.0,
          'cushion': 27040.0
        },
        '3.5': {
          'round': 41600.0,
          'oval': 37440.0,
          'pear': 37440.0,
          'emerald': 28288.0,
          'radiant': 28288.0,
          'asscher': 26873.6,
          'marquise': 41600.0,
          'cushion': 27040.0
        },
        '3.75': {
          'round': 41600.0,
          'oval': 37440.0,
          'pear': 37440.0,
          'emerald': 28288.0,
          'radiant': 28288.0,
          'asscher': 26873.6,
          'marquise': 41600.0,
          'cushion': 27040.0
        },
        '4.0': {
          'round': 80000.0,
          'oval': 72000.0,
          'pear': 72000.0,
          'emerald': 54400.0,
          'radiant': 54400.0,
          'asscher': 51680.0,
          'marquise': 80000.0,
          'cushion': 52000.0
        },
        '4.25': {
          'round': 80000.0,
          'oval': 72000.0,
          'pear': 72000.0,
          'emerald': 54400.0,
          'radiant': 54400.0,
          'asscher': 51680.0,
          'marquise': 80000.0,
          'cushion': 52000.0
        },
        '4.5': {
          'round': 80000.0,
          'oval': 72000.0,
          'pear': 72000.0,
          'emerald': 54400.0,
          'radiant': 54400.0,
          'asscher': 51680.0,
          'marquise': 80000.0,
          'cushion': 52000.0
        },
        '4.75': {
          'round': 80000.0,
          'oval': 72000.0,
          'pear': 72000.0,
          'emerald': 54400.0,
          'radiant': 54400.0,
          'asscher': 51680.0,
          'marquise': 80000.0,
          'cushion': 52000.0
        },
        '5.0': {
          'round': 80000.0,
          'oval': 72000.0,
          'pear': 72000.0,
          'emerald': 54400.0,
          'radiant': 54400.0,
          'asscher': 51680.0,
          'marquise': 80000.0,
          'cushion': 52000.0
        }
      },
      'white-diamond': {
        '0.75': {
          'round': 2420.0,
          'oval': 2178.0,
          'pear': 2178.0,
          'emerald': 1645.6,
          'radiant': 1645.6,
          'asscher': 1563.32,
          'marquise': 2420.0,
          'cushion': 1573.0
        },
        '1.00': {
          'round': 4400.0,
          'oval': 3960.0,
          'pear': 3960.0,
          'emerald': 2992.0,
          'radiant': 2992.0,
          'asscher': 2842.4,
          'marquise': 4400.0,
          'cushion': 2860.0
        },
        '1.25': {
          'round': 8360.0,
          'oval': 7524.0,
          'pear': 7524.0,
          'emerald': 5684.8,
          'radiant': 5684.8,
          'asscher': 5400.56,
          'marquise': 8360.0,
          'cushion': 5434.0
        },
        '1.50': {
          'round': 10780.0,
          'oval': 9702.0,
          'pear': 9702.0,
          'emerald': 7330.4,
          'radiant': 7330.4,
          'asscher': 6963.88,
          'marquise': 10780.0,
          'cushion': 7007.0
        },
        '1.75': {
          'round': 16720.0,
          'oval': 15048.0,
          'pear': 15048.0,
          'emerald': 11369.6,
          'radiant': 11369.6,
          'asscher': 10801.12,
          'marquise': 16720.0,
          'cushion': 10868.0
        },
        '2.00': {
          'round': 22000.0,
          'oval': 19800.0,
          'pear': 19800.0,
          'emerald': 14960.0,
          'radiant': 14960.0,
          'asscher': 14212.0,
          'marquise': 22000.0,
          'cushion': 14300.0
        },
        '2.25': {
          'round': 22000.0,
          'oval': 19800.0,
          'pear': 19800.0,
          'emerald': 14960.0,
          'radiant': 14960.0,
          'asscher': 14212.0,
          'marquise': 22000.0,
          'cushion': 14300.0
        },
        '2.50': {
          'round': 33000.0,
          'oval': 29700.0,
          'pear': 29700.0,
          'emerald': 22440.0,
          'radiant': 22440.0,
          'asscher': 21318.0,
          'marquise': 33000.0,
          'cushion': 21450.0
        },
        '2.75': {
          'round': 33000.0,
          'oval': 29700.0,
          'pear': 29700.0,
          'emerald': 22440.0,
          'radiant': 22440.0,
          'asscher': 21318.0,
          'marquise': 33000.0,
          'cushion': 21450.0
        },
        '3.00': {
          'round': 57200.0,
          'oval': 51480.0,
          'pear': 51480.0,
          'emerald': 38896.0,
          'radiant': 38896.0,
          'asscher': 36951.2,
          'marquise': 57200.0,
          'cushion': 37180.0
        },
        '3.25': {
          'round': 57200.0,
          'oval': 51480.0,
          'pear': 51480.0,
          'emerald': 38896.0,
          'radiant': 38896.0,
          'asscher': 36951.2,
          'marquise': 57200.0,
          'cushion': 37180.0
        },
        '3.5': {
          'round': 57200.0,
          'oval': 51480.0,
          'pear': 51480.0,
          'emerald': 38896.0,
          'radiant': 38896.0,
          'asscher': 36951.2,
          'marquise': 57200.0,
          'cushion': 37180.0
        },
        '3.75': {
          'round': 57200.0,
          'oval': 51480.0,
          'pear': 51480.0,
          'emerald': 38896.0,
          'radiant': 38896.0,
          'asscher': 36951.2,
          'marquise': 57200.0,
          'cushion': 37180.0
        },
        '4.0': {
          'round': 110000.0,
          'oval': 99000.0,
          'pear': 99000.0,
          'emerald': 74800.0,
          'radiant': 74800.0,
          'asscher': 71060.0,
          'marquise': 110000.0,
          'cushion': 71500.0
        },
        '4.25': {
          'round': 110000.0,
          'oval': 99000.0,
          'pear': 99000.0,
          'emerald': 74800.0,
          'radiant': 74800.0,
          'asscher': 71060.0,
          'marquise': 110000.0,
          'cushion': 71500.0
        },
        '4.5': {
          'round': 110000.0,
          'oval': 99000.0,
          'pear': 99000.0,
          'emerald': 74800.0,
          'radiant': 74800.0,
          'asscher': 71060.0,
          'marquise': 110000.0,
          'cushion': 71500.0
        },
        '4.75': {
          'round': 110000.0,
          'oval': 99000.0,
          'pear': 99000.0,
          'emerald': 74800.0,
          'radiant': 74800.0,
          'asscher': 71060.0,
          'marquise': 110000.0,
          'cushion': 71500.0
        },
        '5.0': {
          'round': 110000.0,
          'oval': 99000.0,
          'pear': 99000.0,
          'emerald': 74800.0,
          'radiant': 74800.0,
          'asscher': 71060.0,
          'marquise': 110000.0,
          'cushion': 71500.0
        }
      },
      'warm-white-diamond': {
        '0.75': {
          'round': 1650.0,
          'oval': 1485.0,
          'pear': 1485.0,
          'emerald': 1122.0,
          'radiant': 1122.0,
          'asscher': 1065.9,
          'marquise': 1650.0,
          
          'cushion': 1072.5
        },
        '1.00': {
          'round': 3000.0,
          'oval': 2700.0,
          'pear': 2700.0,
          'emerald': 2040.0,
          'radiant': 2040.0,
          'asscher': 1938.0,
          'marquise': 3000.0,
          
          'cushion': 1950.0
        },
        '1.25': {
          'round': 5700.0,
          'oval': 5130.0,
          'pear': 5130.0,
          'emerald': 3876.0,
          'radiant': 3876.0,
          'asscher': 3682.2,
          'marquise': 5700.0,
          
          'cushion': 3705.0
        },
        '1.50': {
          'round': 7350.0,
          'oval': 6615.0,
          'pear': 6615.0,
          'emerald': 4998.0,
          'radiant': 4998.0,
          'asscher': 4748.1,
          'marquise': 7350.0,
          
          'cushion': 4777.5
        },
        '1.75': {
          'round': 11400.0,
          'oval': 10260.0,
          'pear': 10260.0,
          'emerald': 7752.0,
          'radiant': 7752.0,
          'asscher': 7364.4,
          'marquise': 11400.0,
          
          'cushion': 7410.0
        },
        '2.00': {
          'round': 15000.0,
          'oval': 13500.0,
          'pear': 13500.0,
          'emerald': 10200.0,
          'radiant': 10200.0,
          'asscher': 9690.0,
          'marquise': 15000.0,
          
          'cushion': 9750.0
        },
        '2.25': {
          'round': 15000.0,
          'oval': 13500.0,
          'pear': 13500.0,
          'emerald': 10200.0,
          'radiant': 10200.0,
          'asscher': 9690.0,
          'marquise': 15000.0,
          
          'cushion': 9750.0
        },
        '2.50': {
          'round': 22500.0,
          'oval': 20250.0,
          'pear': 20250.0,
          'emerald': 15300.0,
          'radiant': 15300.0,
          'asscher': 14535.0,
          'marquise': 22500.0,
          
          'cushion': 14625.0
        },
        '2.75': {
          'round': 22500.0,
          'oval': 20250.0,
          'pear': 20250.0,
          'emerald': 15300.0,
          'radiant': 15300.0,
          'asscher': 14535.0,
          'marquise': 22500.0,
          
          'cushion': 14625.0
        },
        '3.00': {
          'round': 39000.0,
          'oval': 35100.0,
          'pear': 35100.0,
          'emerald': 26520.0,
          'radiant': 26520.0,
          'asscher': 25194.0,
          'marquise': 39000.0,
          
          'cushion': 25350.0
        },
        '3.25': {
          'round': 39000.0,
          'oval': 35100.0,
          'pear': 35100.0,
          'emerald': 26520.0,
          'radiant': 26520.0,
          'asscher': 25194.0,
          'marquise': 39000.0,
          
          'cushion': 25350.0
        },
        '3.5': {
          'round': 39000.0,
          'oval': 35100.0,
          'pear': 35100.0,
          'emerald': 26520.0,
          'radiant': 26520.0,
          'asscher': 25194.0,
          'marquise': 39000.0,
          
          'cushion': 25350.0
        },
        '3.75': {
          'round': 39000.0,
          'oval': 35100.0,
          'pear': 35100.0,
          'emerald': 26520.0,
          'radiant': 26520.0,
          'asscher': 25194.0,
          'marquise': 39000.0,
          
          'cushion': 25350.0
        },
        '4.0': {
          'round': 75000.0,
          'oval': 67500.0,
          'pear': 67500.0,
          'emerald': 51000.0,
          'radiant': 51000.0,
          'asscher': 48450.0,
          'marquise': 75000.0,
          
          'cushion': 48750.0
        },
        '4.25': {
          'round': 75000.0,
          'oval': 67500.0,
          'pear': 67500.0,
          'emerald': 51000.0,
          'radiant': 51000.0,
          'asscher': 48450.0,
          'marquise': 75000.0,
          
          'cushion': 48750.0
        },
        '4.5': {
          'round': 75000.0,
          'oval': 67500.0,
          'pear': 67500.0,
          'emerald': 51000.0,
          'radiant': 51000.0,
          'asscher': 48450.0,
          'marquise': 75000.0,
          
          'cushion': 48750.0
        },
        '4.75': {
          'round': 75000.0,
          'oval': 67500.0,
          'pear': 67500.0,
          'emerald': 51000.0,
          'radiant': 51000.0,
          'asscher': 48450.0,
          'marquise': 75000.0,
          'cushion': 48750.0
        },
        '5.0': {
          'round': 75000.0,
          'oval': 67500.0,
          'pear': 67500.0,
          'emerald': 51000.0,
          'radiant': 51000.0,
          'asscher': 48450.0,
          'marquise': 75000.0,
          'cushion': 48750.0
        }
      },
      'sapphire': {
        '0.75': {
          'round': 825.0,
          'oval': 742.5,
          'pear': 742.5,
          'emerald': 561.0,
          'radiant': 561.0,
          'asscher': 532.95,
          'marquise': 825.0,
          'cushion': 536.25
        },
        '1.00': {
          'round': 1500.0,
          'oval': 1350.0,
          'pear': 1350.0,
          'emerald': 1020.0,
          'radiant': 1020.0,
          'asscher': 969.0,
          'marquise': 1500.0,
          'cushion': 975.0
        },
        '1.25': {
          'round': 2850.0,
          'oval': 2565.0,
          'pear': 2565.0,
          'emerald': 1938.0,
          'radiant': 1938.0,
          'asscher': 1841.1,
          'marquise': 2850.0,
          'cushion': 1852.5
        },
        '1.50': {
          'round': 3675.0,
          'oval': 3307.5,
          'pear': 3307.5,
          'emerald': 2499.0,
          'radiant': 2499.0,
          'asscher': 2374.05,
          'marquise': 3675.0,
          'cushion': 2388.75
        },
        '1.75': {
          'round': 5700.0,
          'oval': 5130.0,
          'pear': 5130.0,
          'emerald': 3876.0,
          'radiant': 3876.0,
          'asscher': 3682.2,
          'marquise': 5700.0,
          'cushion': 3705.0
        },
        '2.00': {
          'round': 7500.0,
          'oval': 6750.0,
          'pear': 6750.0,
          'emerald': 5100.0,
          'radiant': 5100.0,
          'asscher': 4845.0,
          'marquise': 7500.0,
          'cushion': 4875.0
        },
        '2.25': {
          'round': 7500.0,
          'oval': 6750.0,
          'pear': 6750.0,
          'emerald': 5100.0,
          'radiant': 5100.0,
          'asscher': 4845.0,
          'marquise': 7500.0,
          'cushion': 4875.0
        },
        '2.50': {
          'round': 11250.0,
          'oval': 10125.0,
          'pear': 10125.0,
          'emerald': 7650.0,
          'radiant': 7650.0,
          'asscher': 7267.5,
          'marquise': 11250.0,
          'cushion': 7312.5
        },
        '2.75': {
          'round': 11250.0,
          'oval': 10125.0,
          'pear': 10125.0,
          'emerald': 7650.0,
          'radiant': 7650.0,
          'asscher': 7267.5,
          'marquise': 11250.0,
          'cushion': 7312.5
        },
        '3.00': {
          'round': 19500.0,
          'oval': 17550.0,
          'pear': 17550.0,
          'emerald': 13260.0,
          'radiant': 13260.0,
          'asscher': 12597.0,
          'marquise': 19500.0,
          'cushion': 12675.0
        },
        '3.25': {
          'round': 19500.0,
          'oval': 17550.0,
          'pear': 17550.0,
          'emerald': 13260.0,
          'radiant': 13260.0,
          'asscher': 12597.0,
          'marquise': 19500.0,
          'cushion': 12675.0
        },
        '3.5': {
          'round': 19500.0,
          'oval': 17550.0,
          'pear': 17550.0,
          'emerald': 13260.0,
          'radiant': 13260.0,
          'asscher': 12597.0,
          'marquise': 19500.0,
          'cushion': 12675.0
        },
        '3.75': {
          'round': 19500.0,
          'oval': 17550.0,
          'pear': 17550.0,
          'emerald': 13260.0,
          'radiant': 13260.0,
          'asscher': 12597.0,
          'marquise': 19500.0,
          'cushion': 12675.0
        },
        '4.0': {
          'round': 37500.0,
          'oval': 33750.0,
          'pear': 33750.0,
          'emerald': 25500.0,
          'radiant': 25500.0,
          'asscher': 24225.0,
          'marquise': 37500.0,
          'cushion': 24375.0
        },
        '4.25': {
          'round': 37500.0,
          'oval': 33750.0,
          'pear': 33750.0,
          'emerald': 25500.0,
          'radiant': 25500.0,
          'asscher': 24225.0,
          'marquise': 37500.0,
          'cushion': 24375.0
        },
        '4.5': {
          'round': 37500.0,
          'oval': 33750.0,
          'pear': 33750.0,
          'emerald': 25500.0,
          'radiant': 25500.0,
          'asscher': 24225.0,
          'marquise': 37500.0,
          'cushion': 24375.0
        },
        '4.75': {
          'round': 37500.0,
          'oval': 33750.0,
          'pear': 33750.0,
          'emerald': 25500.0,
          'radiant': 25500.0,
          'asscher': 24225.0,
          'marquise': 37500.0,
          'cushion': 24375.0
        },
        '5.0': {
          'round': 37500.0,
          'oval': 33750.0,
          'pear': 33750.0,
          'emerald': 25500.0,
          'radiant': 25500.0,
          'asscher': 24225.0,
          'marquise': 37500.0,
          'cushion': 24375.0
        }
      },
    },
    'step-metal': {
      '14ct-yellow-gold': 300.0,
      '14ct-white-gold': 300.0,
      '14ct-rose-gold': 300.0,
      '18ct-yellow-gold': 450.0,
      '18ct-white-gold': 450.0,
      '18ct-rose-gold': 450.0
    },
    'step-accent-stone': {
      '0.75': {
        'round': 550.0,
        'oval': 550.0,
        'pear': 550.0,
        'marquise': 400.0,
        'baguette': 880.0,
        'kite': 1800.0,
        'half moon': 1875.0,
        'trapezoid': 1687.5,
        'tapered': 1125.0
      },
      '1.00': {
        'round': 550.0,
        'oval': 550.0,
        'pear': 550.0,
        'marquise': 400.0,
        'baguette': 880.0,
        'kite': 1800.0,
        'half moon': 1875.0,
        'trapezoid': 1687.5,
        'tapered': 1125.0
      },
      '1.25': {
        'round': 550.0,
        'oval': 550.0,
        'pear': 550.0,
        'marquise': 400.0,
        'baguette': 880.0,
        'kite': 1800.0,
        'half moon': 1875.0,
        'trapezoid': 1687.5,
        'tapered': 1125.0
      },
      '1.50': {
        'round': 550.0,
        'oval': 550.0,
        'pear': 550.0,
        'marquise': 400.0,
        'baguette': 880.0,
        'kite': 1800.0,
        'half moon': 1875.0,
        'trapezoid': 1687.5,
        'tapered': 1125.0
      },
      '1.75': {
        'round': 1800.0,
        'oval': 2300.0,
        'pear': 2300.0,
        'marquise': 800.0,
        'baguette': 2200.0,
        'kite': 2400.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.00': {
        'round': 1800.0,
        'oval': 2300.0,
        'pear': 2300.0,
        'marquise': 800.0,
        'baguette': 2200.0,
        'kite': 2400.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.25': {
        'round': 1800.0,
        'oval': 2300.0,
        'pear': 2300.0,
        'marquise': 800.0,
        'baguette': 2200.0,
        'kite': 2400.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.50': {
        'round': 1800.0,
        'oval': 2300.0,
        'pear': 2300.0,
        'marquise': 800.0,
        'baguette': 2200.0,
        'kite': 2400.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.75': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '3.00': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '3.25': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '3.5': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '3.75': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '4.0': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '4.25': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '4.5': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '4.75': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      },
      '5.0': {
        'round': 3240.0,
        'oval': 4140.0,
        'pear': 4140.0,
        'marquise': 1440.0,
        'baguette': 3960.0,
        'kite': 4320.0,
        'half moon': 4500.0,
        'trapezoid': 4050.0,
        'tapered': 2700.0
      }
    },
    'step-second-accent-stone': {
      '0.75': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '1.00': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '1.25': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '1.50': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '1.75': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.00': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.25': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.50': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '2.75': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '3.00': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '3.25': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '3.5': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '3.75': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '4.0': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '4.25': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '4.5': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '4.75': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      },
      '5.0': {
        'round': 200.0,
        'pear': 300.0,
        'marquise': 300.0,
        'baguette': 400.0,
        'kite': 1200.0,
        'half moon': 2500.0,
        'trapezoid': 2250.0,
        'tapered': 1500.0
      }
    }
  };

  let steps = document.querySelectorAll(".orderStep");
  let currentStep = 0;
  steps[currentStep].classList.add("active");

  let progressBarFill = document.querySelector(".progress-bar-fill");
  progressBarFill.style.width = "0%"; // Initialize to 0%

  const nextButton = document.querySelector(".nextButton");
  const backButton = document.querySelector(".backButton");
  const submitForm = document.querySelector(".submitForm");
  const orderSummaryEl = document.querySelector(".orderSummary");
  const submitButton = document.querySelector('button[type="submit"]');

  let state = {
    selections: new Array(steps.length).fill(null),
  };

  submitForm.style.display = "none"; // Initially hide the submit form

  // Function to check if the step is relevant for the current design style
  function isStepRelevant(stepId, designStyle) {
    const baseRelevantSteps = {
      Solitaire: [
        "step-centre-stone",
        "step-stone-type",
        "step-stone-size",
        "step-band",
        "step-orientation",
        "step-metal",
        "step-setting-style",
      ],
      TwoStone: [
        "step-left-stone",
        "step-stone-type",
        "step-right-stone",
        "step-left-stone-size",
        "step-right-stone-size",
        "step-band",
        "step-metal",
      ],
      Trilogy: [
        "step-centre-stone",
        "step-stone-type",
        "step-stone-size",
        "step-band",
        "step-metal",
        "step-setting-style",
      ],
      ThreeStone: [
        "step-centre-stone",
        "step-stone-type",
        "step-accent-stone",
        "step-stone-size",
        "step-band",
        "step-metal",
        "step-setting-style",
      ],
      FiveStone: [
        "step-centre-stone",
        "step-stone-type",
        "step-accent-stone",
        "step-second-accent-stone",
        "step-stone-size",
        "step-band",
        "step-metal",
        "step-setting-style",
      ],
      // Add clusters here
    };

    // Determine if 'step-diamond-type' should be included
    let relevantSteps = [...baseRelevantSteps[designStyle]];
    if (currentStoneType.includes("diamond")) {
      relevantSteps.push("step-diamond-type");
    }

    return relevantSteps.includes(stepId);
  }

  nextButton.addEventListener("click", function () {
    if (nextButton.disabled) return;

    steps[currentStep].classList.remove("active");

    // Find the next relevant step
    do {
      currentStep++;
    } while (
      currentStep < steps.length && // Check all steps including the last one
      !isStepRelevant(steps[currentStep].id, currentDesignStyle)
    );

    if (currentStep >= steps.length) {
      // If we are entering the order summary
      updateOrderSummary(
        gatherOrderData().attributes,
        gatherOrderData().totalPrice,
        orderSummaryEl
      );
      submitForm.style.display = "block";
      progressBarFill.style.width = "100%"; // Set progress bar to 100% when entering order summary
      document.querySelector(".sketch-app").classList.add("order-summary");
    } else {
      steps[currentStep].classList.add("active");
      // Update progress bar based on current step, but not full until the last step
      progressBarFill.style.width = (currentStep / steps.length) * 100 + "%";
      document.querySelector(".sketch-app").classList.remove("order-summary");
    }

    updateButtonVisibility();
  });

  // Modified backButton event listener
  backButton.addEventListener("click", function () {
    if (backButton.disabled) return;
    document.querySelector(".sketch-app").classList.remove("order-summary"); // Show order summary
    if (currentStep === steps.length) {
      submitForm.style.display = "none";
      currentStep--;
    }

    do {
      steps[currentStep].classList.remove("active");
      if (currentStep > 0) {
        currentStep--;
      }
    } while (currentStep > 0 && !isStepRelevant(steps[currentStep].id, currentDesignStyle));

    steps[currentStep].classList.add("active");
    progressBarFill.style.width = (currentStep / steps.length) * 100 + "%";
    updateButtonVisibility();
  });

  steps.forEach(function (step, index) {
    let selects = step.querySelectorAll("select");
    selects.forEach(function (select) {
      select.addEventListener("change", function () {
        state.selections[index] = select.value;
        updateButtonVisibility();

        // Check if the current step is the design style selection
        if (step.id === "step-design-style") {
          onDesignStyleSelected(select.value);
        }

        // Update second accent stone options if accent stone changes
        if (step.id === "step-accent-stone") {
          updateSecondAccentStoneOptions(select.value);
        }
      });
    });
  });

  // Ring builder state
  let currentStone = "";
  let currentStoneType = "";
  let currentDiamondType = "";
  let currentLeftStone = "";
  let currentRightStone = "";
  let currentAccentStone = "";
  let currentSecondAccentStone = "";
  let currentSettingStyle = "4-drop";
  let currentOrientation = "north-south"; // Add this line to your existing state variables
  let currentMetal = "";
  let currentBandProfile = "";
  let currentStoneSizeIndex = 0;
  let currentLeftStoneSizeIndex = 0;
  let currentRightStoneSizeIndex = 0;  
  let currentDesignStyle = "Solitaire"; // Add this line to your existing state variables

  // Use asset URLs from Liquid template instead of hardcoded basePath
  const basePath = window.assetUrls?.basePath || ""; 

  const designStyleDefaults = {
    Solitaire: {
      centreStone: "round", // Default stone for Solitaire
      stoneType: "white-diamond",
      settingStyle: "4-drop",
      bandProfile: "skinny-round",
      metal: "14ct-yellow-gold",
      stoneSizeIndex: 0,
      orientation: "north-south", // Default orientation for Solitaire
    },
    TwoStone: {
      leftStone: "round", // Default stone for Solitaire
      rightStone: "pear", // Default stone for Solitaire
      stoneType: "white-diamond",
      settingStyle: "4-drop",
      bandProfile: "skinny-round",
      metal: "14ct-yellow-gold",
      leftStoneSizeIndex: 0,
    },
    Trilogy: {
      centreStone: "asscher", // Default centre stone for Trilogy
      stoneType: "white-diamond",
      settingStyle: "4-drop",
      bandProfile: "skinny-square",
      metal: "14ct-yellow-gold",
      stoneSizeIndex: 0,
    },
    ThreeStone: {
      centreStone: "radiant", // Default centre stone for Three Stone
      stoneType: "white-diamond",
      settingStyle: "4-drop",
      bandProfile: "skinny-knifeedge",
      metal: "14ct-yellow-gold",
      accentStone: "baguette", // Default accent stone for Three Stone
      stoneSizeIndex: 0,
    },
    FiveStone: {
      centreStone: "emerald", // Default centre stone for Three Stone
      stoneType: "white-diamond",
      settingStyle: "4-drop",
      bandProfile: "skinny-tapered",
      accentStone: "trapezoid", // Default accent stone for Three Stone
      metal: "14ct-yellow-gold",
      secondAccentStone: "tapered", // Default second accent stone for Three Stone
      stoneSizeIndex: 0,
    },
    // ... Add configurations for other design styles ...
  };

  // Function to update the second accent stone options
  function updateSecondAccentStoneOptions(selectedAccentStone) {
    const secondAccentStoneSelect =
      document.getElementById("secondAccentStone");
    const options = secondAccentStoneSelect.options;

    for (let i = options.length - 1; i >= 0; i--) {
      secondAccentStoneSelect.remove(i);
    }

    const allowedOptions = ["round", "kite", "marquise", "pear"];
    const allOptions = [
      'round',
      'pear',
      'marquise',
      'baguette',
      'kite',
      'moon',
      'trapezoid',
      'tapered'
    ]; // Add all the options here

    if (["kite", "pear", "marquise"].includes(selectedAccentStone)) {
      allowedOptions.forEach(function (optionValue) {
        const option = document.createElement("option");
        option.value = optionValue;
        option.text =
          optionValue.charAt(0).toUpperCase() + optionValue.slice(1);
        secondAccentStoneSelect.add(option);
      });
    } else {
      // Repopulate with all original options
      allOptions.forEach(function (optionValue) {
        const option = document.createElement("option");
        option.value = optionValue;
        option.text =
          optionValue.charAt(0).toUpperCase() + optionValue.slice(1);
        secondAccentStoneSelect.add(option);
      });
    }
  }

  // Function to handle design style selection
  function onDesignStyleSelected(designStyle) {
    currentDesignStyle = designStyle;
    initializeRingPreview(designStyle);
  }

  function initializeRingPreview(designStyle) {
    const defaults = designStyleDefaults[designStyle];

    if (!defaults) return; // If no defaults are defined for the style

    // Set the current state based on defaults
    currentStone = defaults.centreStone;
    currentStoneType = defaults.stoneType;
    currentDiamondType = defaults.diamondType;
    currentLeftStone = defaults.leftStone;
    currentRightStone = defaults.rightStone;
    currentSettingStyle = defaults.settingStyle;
    currentOrientation = defaults.orientation;
    currentBandProfile = defaults.bandProfile;
    currentMetal = defaults.metal;
    currentAccentStone = defaults.accentStone;
    currentSecondAccentStone = defaults.secondAccentStone;
    currentStoneSizeIndex = defaults.stoneSizeIndex;

    // Update select elements to reflect these defaults
    updateSelectElement("centreStone", currentStone);
    updateSelectElement("stoneType", currentStoneType);
    updateSelectElement("centreDiamondType", currentDiamondType);
    updateSelectElement("leftStone", currentLeftStone);
    updateSelectElement("rightStone", currentRightStone);
    updateSelectElement("accentStone", currentAccentStone);
    updateSelectElement("secondAccentStone", currentSecondAccentStone);
    updateSelectElement("stoneSize", currentStoneSizeIndex);
    updateSelectElement("leftStoneSize", currentLeftStoneSizeIndex);
    updateSelectElement("rightStoneSize", currentRightStoneSizeIndex);
    updateSelectElement("bandProfile", currentBandProfile);
    updateSelectElement("metal", currentMetal);
    updateSelectElement("settingStyle", currentSettingStyle);
    updateSelectElement("orientation", currentOrientation);

    updateRingPreview(); // Update the ring preview
  }

  // Helper function to update select element value
  function updateSelectElement(selectId, value) {
    if (value) {
      const selectElement = document.getElementById(selectId);
      if (selectElement) {
        selectElement.value = value;
      }
    }
  }

  // Update ring preview based on the current selections
  function createImage(src, baseClass, stoneName = "", isNew = false) {
    const img = new Image();
    img.src = src;
    let classes = `${baseClass} ${stoneName}`.trim();
    if (isNew) {
      classes += " updateLayer"; // Add the fade-in class if the image is new or updated
    }
    img.className = classes;
    return img;
  }

  function updateRingPreview() {
    console.log("Updating ring preview...");
    const wrapper = document.getElementById("ringPreview");
    wrapper.innerHTML = ""; // Clear existing content

    // Track changes for each stone type
    let centreStoneChanged = state.previousCentreStone !== currentStone;
    let leftStoneChanged = state.previousLeftStone !== currentLeftStone;
    let rightStoneChanged = state.previousRightStone !== currentRightStone;
    let accentStoneChanged = state.previousAccentStone !== currentAccentStone;

    // Update the previous state
    state.previousCentreStone = currentStone;
    state.previousLeftStone = currentLeftStone;
    state.previousRightStone = currentRightStone;
    state.previousAccentStone = currentAccentStone;

    if (currentAccentStone === "baguette") {
      currentAccentStone = "rectangle";
    }

    if (currentSecondAccentStone === "baguette") {
      currentSecondAccentStone = "rectangle";
    }
    // Always add Centre Stone for Solitaire, Trilogy, ThreeStone, and FiveStone
    if (currentDesignStyle !== "TwoStone") {
      const stoneImageKey = `${currentSettingStyle}-${currentStone}`;
      const stoneImageUrl = window.assetUrls?.stoneImages?.[stoneImageKey] || `${basePath}stone-${currentSettingStyle}-${currentStone}.png`;
      const centreStoneImg = createImage(
        stoneImageUrl,
        "centre-stone",
        currentStone.toLowerCase(),
        centreStoneChanged
      );
      wrapper.appendChild(centreStoneImg);
    }

    // Handle different design styles
    switch (currentDesignStyle) {
      case "TwoStone":
        const leftStoneKey = `4-dot-${currentLeftStone}`;
        const rightStoneKey = `4-dot-${currentRightStone}`;
        const leftStoneUrl = window.assetUrls?.stoneImages?.[leftStoneKey] || `${basePath}stone-4-dot-${currentLeftStone}-tilt-2.png`;
        const rightStoneUrl = window.assetUrls?.stoneImages?.[rightStoneKey] || `${basePath}stone-4-dot-${currentRightStone}-tilt-15.png`;
        const leftStoneImg = createImage(
          leftStoneUrl,
          "left-stone",
          currentLeftStone.toLowerCase(),
          leftStoneChanged
        );
        const rightStoneImg = createImage(
          rightStoneUrl,
          "right-stone",
          currentRightStone.toLowerCase(),
          rightStoneChanged
        );
        wrapper.appendChild(leftStoneImg);
        wrapper.appendChild(rightStoneImg);
        break;
      case "Trilogy":
        const leftTriStoneKey = `4-dot-${currentStone}`;
        const leftTriStoneUrl = window.assetUrls?.stoneImages?.[leftTriStoneKey] || `${basePath}stone-4-dot-${currentStone}.png`;
        const leftTriStoneImg = createImage(
          leftTriStoneUrl,
          "left-tri-stone",
          currentStone.toLowerCase(),
          centreStoneChanged
        );
        const rightTriStoneImg = createImage(
          leftTriStoneUrl,
          "right-tri-stone",
          currentStone.toLowerCase(),
          centreStoneChanged
        );
        wrapper.appendChild(leftTriStoneImg);
        wrapper.appendChild(rightTriStoneImg);
        break;
      case "ThreeStone":
        const accentStoneKey = `4-dot-${currentAccentStone}`;
        const accentStoneUrl = window.assetUrls?.stoneImages?.[accentStoneKey] || `${basePath}stone-4-dot-${currentAccentStone}.png`;
        const leftAccentStoneImg = createImage(
          accentStoneUrl,
          "left-accent-stone",
          currentAccentStone.toLowerCase(),
          accentStoneChanged
        );
        const rightAccentStoneImg = createImage(
          accentStoneUrl,
          "right-accent-stone",
          currentAccentStone.toLowerCase(),
          accentStoneChanged
        );
        wrapper.appendChild(leftAccentStoneImg);
        wrapper.appendChild(rightAccentStoneImg);
        break;
      case "FiveStone":
        const fiveStoneAccentKey = `4-dot-${currentAccentStone}`;
        const fiveStoneAccentUrl = window.assetUrls?.stoneImages?.[fiveStoneAccentKey] || `${basePath}stone-4-dot-${currentAccentStone}.png`;
        const leftAccentFiveStoneImg = createImage(
          fiveStoneAccentUrl,
          "left-accent-stone",
          currentAccentStone.toLowerCase(),
          accentStoneChanged
        );
        const rightAccentFiveStoneImg = createImage(
          fiveStoneAccentUrl,
          "right-accent-stone",
          currentAccentStone.toLowerCase(),
          accentStoneChanged
        );
        const secondAccentStoneKey = `4-dot-${currentSecondAccentStone}`;
        const secondAccentStoneUrl = window.assetUrls?.stoneImages?.[secondAccentStoneKey] || `${basePath}stone-4-dot-${currentSecondAccentStone}.png`;
        const leftSecondAccentStoneImg = createImage(
          secondAccentStoneUrl,
          "left-second-accent-stone",
          currentSecondAccentStone.toLowerCase()
        );
        const rightSecondAccentStoneImg = createImage(
          secondAccentStoneUrl,
          "right-second-accent-stone",
          currentSecondAccentStone.toLowerCase()
        );
        wrapper.appendChild(leftAccentFiveStoneImg);
        wrapper.appendChild(rightAccentFiveStoneImg);
        wrapper.appendChild(leftSecondAccentStoneImg);
        wrapper.appendChild(rightSecondAccentStoneImg);
        break;
    }

    // Add Band Profile
    const bandImageUrl = window.assetUrls?.bandImages?.[currentBandProfile] || `${basePath}band-${currentBandProfile}.png`;
    if (bandImageUrl) {
      const bandImg = createImage(
        bandImageUrl,
        "band"
      );
      wrapper.appendChild(bandImg);
    } else {
      console.warn(`Band image not found for: ${currentBandProfile}`);
    }

    // Update wrapper class names
    wrapper.className = "sketch-image-wrapper";

    if (currentDesignStyle === "Solitaire") {
      wrapper.classList.add(currentOrientation);
    }
    if (currentDesignStyle === "TwoStone") {
      wrapper.classList.add(
        `left-size-${currentLeftStoneSizeIndex + 1}`,
        `right-size-${currentRightStoneSizeIndex + 1}`
      );
    } else {
      wrapper.classList.add(`size-${currentStoneSizeIndex + 1}`);
    }
  }

  let selectOptions = document.querySelectorAll(".orderStep select");

  selectOptions.forEach(function (select) {
    select.addEventListener("change", function () {
      console.log("select changed.....");
      const selectedOption = this.value; // 'this' refers to the select element
      const stepIndex = Array.from(steps).indexOf(this.closest(".orderStep"));
      state.selections[stepIndex] = selectedOption;
      updateButtonVisibility();

      // Ring builder logic for each step based on select values
      const stepId = this.closest(".orderStep").id;
      switch (stepId) {
        case "step-centre-stone":
          currentStone = selectedOption;
          break;
        case "step-stone-type":
          currentStoneType = selectedOption;
          break;
        case "step-diamond-type":
          currentDiamondType = selectedOption;
          break;
        case "step-left-stone":
          currentLeftStone = selectedOption;
          break;
        case "step-right-stone":
          currentRightStone = selectedOption;
          break;
        case "step-accent-stone":
          currentAccentStone = selectedOption;
          break;
        case "step-second-accent-stone":
          currentSecondAccentStone = selectedOption;
          break;
        case "step-stone-size":
          currentStoneSizeIndex = select.selectedIndex;
          break;
        case "step-left-stone-size":
          currentLeftStoneSizeIndex = select.selectedIndex;
          break;
        case "step-right-stone-size":
          currentRightStoneSizeIndex = select.selectedIndex;
          break;
        case "step-band":
          currentBandProfile = selectedOption;
          break;
        case "step-setting-style":
          currentSettingStyle = selectedOption;
          break;
        case "step-orientation":
          currentOrientation = selectedOption;
          break;
        case "step-metal":
          currentMetal = selectedOption;
          break;
      }

      console.log("currentStone: ", currentStone);
      updateRingPreview();
    });
  });

  function gatherOrderData() {
    let attributes = [];
    let totalPrice = 0;

    // Add the design style attribute
    const designStyleSelect = document.getElementById("designStyle");
    if (designStyleSelect && designStyleSelect.value) {
      let designStyleText =
        designStyleSelect.options[designStyleSelect.selectedIndex].text;
      let designStyleAttribute = {
        create: {
          attribute: {
            key: "Design Style",
            value: designStyleText,
          },
        },
      };
      // Removed the price calculation for the design style attribute
      attributes.push(designStyleAttribute);
    }

    // Add other attributes
    steps.forEach(function (step) {
      if (
        !isStepRelevant(step.id, currentDesignStyle) ||
        step.id === "step-design-style"
      ) {
        return; // Skip irrelevant steps and the design style step
      }
      const select = step.querySelector("select");
      if (select && select.value) {
        let attributeKey = step.querySelector("label").textContent;
        let attributeText = select.options[select.selectedIndex].text;
        let attribute = {
          create: {
            attribute: {
              key: attributeKey,
              value: attributeText,
            },
          },
        };
        // Removed the price calculation for individual attributes
        attributes.push(attribute);
      }
    });

    // Include customer details
    const customerDetails = {
      firstName: document.getElementById("customerFirstName").value,
      lastName: document.getElementById("customerLastName").value,
      email: document.getElementById("customerEmail").value,
      // note: document.getElementById('customerNote').value
    };

    // Calculate the total price using the productPricing object
    totalPrice = calculateTotalPrice();

    return { attributes, totalPrice, customerDetails };
  }

  // Added a new function to calculate the total price based on the selections
  function calculateTotalPrice() {
    let totalPrice = 0;
  
    // Function to check if a value is valid (not null, undefined, 0, or an empty string)
    const isValidValue = value => {
      return value !== null && value !== undefined && value !== 0 && value !== "";
    };
  
    // Calculate the price for step-stone-type
    const stoneTypeSelect = document.getElementById("stoneType");
    const stoneSizeSelect = document.getElementById("stoneSize");
    const stoneShapeSelect = document.getElementById("centreStone");
    const stoneType = stoneTypeSelect.value;
    const stoneSize = stoneSizeSelect.value;
    const stoneShape = stoneShapeSelect.value;
  
    if (stoneTypeSelect && stoneSizeSelect && stoneShapeSelect && currentDesignStyle !== "TwoStone") {
      const stoneTypePricing = productPricing["step-stone-type"][stoneType];
      const stoneSizePricing = stoneTypePricing && stoneTypePricing[stoneSize];
      const stoneShapePricing = stoneSizePricing && stoneSizePricing[stoneShape];
  
      if (isValidValue(stoneTypePricing) && isValidValue(stoneSizePricing) && isValidValue(stoneShapePricing)) {
        totalPrice += stoneShapePricing;
      } else {
        return "*To be confirmed";
      }
    }
  
    // Calculate the price for step-metal
    const metalSelect = document.getElementById("metalType");
    const metalPricing = metalSelect && productPricing["step-metal"][metalSelect.value];
  
    if (isValidValue(metalPricing)) {
      totalPrice += metalPricing;
    } else {
      return "*To be confirmed";
    }
  
    // Calculate additional prices based on the current design style
    switch (currentDesignStyle) {
      case "TwoStone":
        // Calculate the price for step-left-stone and step-right-stone
        const leftStoneSelect = document.getElementById("leftStone");
        const rightStoneSelect = document.getElementById("rightStone");
        const leftStoneSizeSelect = document.getElementById("stoneLeftSize");
        const rightStoneSizeSelect = document.getElementById("stoneRightSize");
        const leftStoneSize = leftStoneSizeSelect.value;
        const rightStoneSize = rightStoneSizeSelect.value;
  
        // Use the same 'step-stone-type' for both left and right stones
        const leftStonePricing = productPricing["step-stone-type"][stoneType] &&
          productPricing["step-stone-type"][stoneType][leftStoneSize] &&
          productPricing["step-stone-type"][stoneType][leftStoneSize][leftStoneSelect.value];
        const rightStonePricing = productPricing["step-stone-type"][stoneType] &&
          productPricing["step-stone-type"][stoneType][rightStoneSize] &&
          productPricing["step-stone-type"][stoneType][rightStoneSize][rightStoneSelect.value];

        console.log("totalPrice", totalPrice);
        console.log("leftStonePricing", leftStonePricing);
        console.log("rightStonePricing", rightStonePricing);

        if (isValidValue(leftStonePricing) && isValidValue(rightStonePricing)) {
          totalPrice += (leftStonePricing + rightStonePricing);
        } else {
          return "*To be confirmed";
        }
        break;
  
      case "Trilogy":
        // Calculate the price for step-accent-stone
        let trilogyStonePricing = productPricing["step-accent-stone"][stoneSize][stoneShape];
        console.log("trilogyStonePricing", trilogyStonePricing);

        if (isValidValue(trilogyStonePricing)) {
          totalPrice += trilogyStonePricing;
        } else {
          return "*To be confirmed";
        }

        break;
      case "ThreeStone":
      case "FiveStone":
        // Calculate the price for step-accent-stone
        let accentStoneSelect = document.getElementById("accentStone");
        let accentStonePricing = accentStoneSelect &&
          productPricing["step-accent-stone"][stoneSize] &&
          productPricing["step-accent-stone"][stoneSize][accentStoneSelect.value];
  
        if (isValidValue(accentStonePricing)) {
          totalPrice += accentStonePricing;
        } else {
          return "*To be confirmed";
        }
  
        if (currentDesignStyle === "FiveStone") {
          // Calculate the price for step-second-accent-stone
          const secondAccentStoneSelect = document.getElementById("secondAccentStone");
          const secondAccentStonePricing = secondAccentStoneSelect &&
            productPricing["step-second-accent-stone"][stoneSize] &&
            productPricing["step-second-accent-stone"][stoneSize][secondAccentStoneSelect.value];
  
          if (isValidValue(secondAccentStonePricing)) {
            totalPrice += secondAccentStonePricing;
          } else {
            return "*To be confirmed";
          }
        }
        break;
  
      default:
        break;
    }

    // Check for lab-grown diamonds and apply discount if applicable
    const diamondTypeSelect = document.getElementById("diamondType");
    if (currentStoneType.includes("diamond") && diamondTypeSelect) {
      const diamondType = diamondTypeSelect.value;
      if (diamondType === "lab-grown-diamond") {
        totalPrice *= 0.40; // Apply 40% discount
      }
    }

    return totalPrice;
  }
  

  function validateForm() {
    const firstName = document.getElementById("customerFirstName").value.trim();
    const lastName = document.getElementById("customerLastName").value.trim();
    const email = document.getElementById("customerEmail").value.trim();

    if (!firstName || !lastName || !validateEmail(email)) {
      return false; // Validation failed
    }

    return true; // Validation passed
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

  function updateOrderSummary(attributes, totalPrice, orderSummaryEl) {
    let summaryHtml = "";

    // Include the design style attribute
    const designStyleSelect = document.getElementById("designStyle");
    if (designStyleSelect && designStyleSelect.value) {
      let designStyleText =
        designStyleSelect.options[designStyleSelect.selectedIndex].text;
      summaryHtml += `<h3>DESIGN STYLE: ${designStyleText}</h3>`;
    }

    // Include other attributes
    steps.forEach(function (step) {
      if (
        !isStepRelevant(step.id, currentDesignStyle) ||
        step.id === "step-design-style"
      ) {
        return; // Skip irrelevant steps and the design style step
      }
      const select = step.querySelector("select");
      if (select && select.value) {
        let attributeKey = step.querySelector("label").textContent;
        let attributeText = select.options[select.selectedIndex].text;
        summaryHtml += `<p><span>${attributeKey}:</span> ${attributeText}</p>`;
      }
    });

    // Updated the order summary to display the calculated total price
    orderSummaryEl.innerHTML = summaryHtml;
    // Display the total price or the "*To be confirmed" message
    let priceDisplay = (typeof totalPrice === 'number') ? `$${totalPrice.toFixed(2)}` : totalPrice;
    orderSummaryEl.innerHTML += `<p class="order-summary-quote"><span>Quote:</span> ${priceDisplay}</p>`;
    
    // Adding the conditional message
    if (typeof totalPrice === 'number') {
        orderSummaryEl.innerHTML += `<p class="approx-price-message">*This price is an approximate, we will confirm once order form is submitted</p>`;
    }    

  }

  async function handleSubmit(title) {
    // Validate form first
    if (!validateForm()) {
      alert("Please fill in all required fields.");
      return false;
    }
  
    const { attributes, totalPrice, customerDetails } = gatherOrderData();
  
    let totalPriceString;
    if (typeof totalPrice === 'number') {      
      totalPriceString = totalPrice.toFixed(2).toString();
    } else {
      totalPriceString = "0";
    }
  
    try {
      const response = await api.draftOrder.create({
        draftOrder: {
          name: "Sketch App Order",
          customerFirstName: customerDetails.firstName,
          customerLastName: customerDetails.lastName,
          customerEmail: customerDetails.email,
          lineItems: [
            {
              create: {
                title: title,
                price: "0.00",
                attributes: attributes,
              },
            },
          ],
        },
      });
  
      console.log("Response from Gadget API:", response);
  
      if (response) {
        showSuccessMessage(); // Display success message
        hideLoading(submitButton); // Hide loading animation
      } else {
        console.error("Error: No invoice URL returned");
        hideLoading(submitButton); // Hide loading animation
      }
    } catch (error) {
      console.error("Error creating DraftOrder:", error);
      hideLoading(submitButton); // Hide loading animation
    }
  }
  

  function showLoading(button) {
    button.textContent = "Please wait... Building custom ring...";
    button.disabled = true;
  }

  function hideLoading(button) {
    button.textContent = "Order Design Renders";
    button.disabled = false;
  }

  function updateButtonVisibility() {
    backButton.disabled = currentStep === 0;
    nextButton.disabled = currentStep >= steps.length;
    backButton.classList.toggle("disabled", currentStep === 0);
    nextButton.classList.toggle("disabled", currentStep >= steps.length);
  }

  function showSuccessMessage() {
    // Create the message container element
    const messageContainer = document.createElement("div");
    messageContainer.className = "success-message";
    messageContainer.textContent =
      "Your request has been successfully submitted. We will contact you soon.";
    // Locate the formRequest div and the parent container
    const formRequest = document.querySelector(".submitForm .formRequest");
    const formContainer = formRequest.parentElement;

    // Insert the message container after the formRequest div
    formContainer.insertBefore(messageContainer, formRequest.nextSibling);

    // Hide only the formRequest part of the form
    formRequest.style.display = "none";
  }

  updateButtonVisibility(); // Initial button visibility update
  updateRingPreview();

  // Initialize ring preview for Solitaire
  onDesignStyleSelected(currentDesignStyle);

  // Attach event listeners to submit buttons
  document
    .getElementById("requestQuote")
    .addEventListener("click", function (event) {
      event.preventDefault();
      handleSubmit("Sketch App - Request Quote");
    });

  document
    .getElementById("orderDesignRenders")
    .addEventListener("click", function (event) {
      event.preventDefault();
      handleSubmit("Sketch App - Order Design Renders");
    });
});



// GraphQL working
// {
//   "draftOrder": {
//     "name": "Draft Order",
//     "lineItems": [
//       {
//         "create": {
//           "title": "test",
//           "price": "10.00",
//           "attributes": [
//             {
//               "create": {
//                 "attribute": {
//                   "key": "color",
//                   "value": "Gold"
//                 }
//               }
//             }
//           ]
//         }
//       }
//     ]
//   }
// }
